<template>
  <div>
    <component
      :is="componentLoader('CarouselParallaxCard')"
      :backgroundImage="data.image"
      link="/"
    >
      <div
        slot="carouselImage"
        class="qt-header-bg"
        :data-bgimage="data.image"
        :style="`background-image: url(${data.image});`"
      >
        <img :src="data.image" alt="Featured image" width="1170" height="512">
      </div>
      <span class="title" slot="title">{{ data.title }}</span>
      <span class="text" slot="text">{{ data.text }}</span>

      <template slot-scope="props" slot="link">
        <a :class="props.aclass" href="signup-step1.html" role="button">
          Visit page
        </a>
      </template>
    </component>
  </div>
</template>
<script>
  import settings from '@fremcast/section/mixins/section';
  export default {
    name: "CarouselParallax",
    props: [
      'data'
    ],
    mixins: [
      settings
    ]
  }
</script>

<style scoped lang="scss">
  .swiper {
    margin-bottom: 40px;
  }
  .swiper-slide {
    font-size: 18px;
    color:#fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 60px;
    background-color: transparent!important;
    justify-content: space-around!important;
    background-size: cover;
    background-position: center;
  }
  .parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 130%;
    height: 100%;
    -webkit-background-size: cover;
    background-size: cover;
    background-position: center;
    background-image: url(https://images.unsplash.com/photo-1522778119026-d647f0596c20?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjYyMDMwfQ);
  }
  .swiper-slide .title {
    font-size: 41px;
    font-weight: 300;
  }
  .swiper-slide .text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.3;
  }
</style>